import { render, staticRenderFns } from "./DeleteConfirmationDialog.vue?vue&type=template&id=29160f60&"
import script from "./DeleteConfirmationDialog.vue?vue&type=script&lang=js&"
export * from "./DeleteConfirmationDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../fodchef/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports